import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Logo from "../../../components/logo/logo";
import image from "../../assets/images/login_pg.svg";
import ArrowButton from "../../ui-elements/arrow-button/arrow-button";
import styles from "./login-layout.module.scss";

interface IProps {
  title: string;
  subTitle?: string | JSX.Element;
  children: JSX.Element;
  showBackButton?: boolean;
  onBack?: () => void;
}

const LoginLayout = (props: IProps) => {
  const navigate = useNavigate();

  return (
    <Container fluid>
      <Row className={`justify-content-center ${styles.loginWrapper}`}>
        <Col className="col-md-11">
          <Row className="align-items-center min-vh-100">
            <Col md={12} lg={6} className="py-5">
              <Row className="justify-content-center">
                <Col className="col-auto">
                  <Logo width={120} height={120} />
                </Col>
              </Row>
              <Row className="mt-4 align-items-center justify-content-center">
                {props.showBackButton && (
                  <Col className="col-auto">
                    <ArrowButton
                      onBack={() => {
                        props.onBack ? props.onBack() : navigate(-1);
                      }}
                    />
                  </Col>
                )}
                <Col className={`${styles.title} col-auto`}>{props.title}</Col>
              </Row>
              {props.subTitle && (
                <Row className="mt-4 justify-content-center">
                  <Col className={`${styles.subTitle} col-10 text-center`}>
                    {props.subTitle}
                  </Col>
                </Row>
              )}
              <Row className="mt-3 justify-content-center">
                <Col className="col-9">{props.children}</Col>
              </Row>
            </Col>
            <Col md={12} lg={6} className="d-none d-lg-block">
              <img
                src={image}
                alt="Login page illustration"
                className="w-100"
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default LoginLayout;
